import React from 'react';

export function Logo({style, ...props}) {
  return (
    <img style={style} src={props.src} alt={props.alt} />
  );
}


// WEBPACK FOOTER //
// ./src/components/logos.js